import { ApiError } from "@wellcheck/api-client";

// backend (handlers/officeinput_session.go) が返す detail と同じ文字列。
// Cookie 無効等、再送すれば回復し得る 401 と区別するために使う。
const CAMPAIGN_ABORTED_DETAIL = "campaign aborted";

export function isCampaignAbortedError(error: unknown): boolean {
  if (!(error instanceof ApiError) || error.status !== 401) {
    return false;
  }
  const data = error.data;
  if (typeof data !== "object" || data === null || !("detail" in data)) {
    return false;
  }
  return (data as { detail: unknown }).detail === CAMPAIGN_ABORTED_DETAIL;
}
